import * as React from "react";
import { useTranslation } from "react-i18next";
import EntityShareModal from "components/permissions/EntityShareModal";
const UserFilterShareModal = ({ filter, toggleShareModalOpen }) => {
  const { t } = useTranslation("enterprise_search");
  return /* @__PURE__ */ React.createElement(
    EntityShareModal,
    {
      entityId: filter.id,
      entityType: "search_filter",
      entityTitle: filter.title || t("user_filter_share_modal.no_title"),
      description: t("user_filter_share_modal.description"),
      onClose: toggleShareModalOpen,
      showShareableEntityURL: false,
      entityTypeTitle: t("user_filter_share_modal.entity_type_title")
    }
  );
};
export default UserFilterShareModal;
